import PlanExtensionProgramList from 'components/PlanExtensionProgramList';

const PlanExtension = () => {
  return <PlanExtensionProgramList programType="undergrad" />;
};

export default PlanExtension;
